import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import service from './common/axios/api';
import axios from './common/axios';

const main = {
    install (Vue) {
        Vue.prototype.path = service;
        Vue.prototype.$axios = axios;
    }
};

Vue.use(ElementUI);
Vue.use(main);

Vue.prototype.$message = ElementUI.Message;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js